const appEnv = process.env.REACT_APP_ENV

export const isProduction = appEnv === 'production'
export const isStaging = appEnv === 'staging'
export const isDevelopment = appEnv === 'development'
export const isLocal =
  typeof window !== 'undefined'
    ? window.location.hostname === 'localhost'
    : !isProduction && !isStaging && !isDevelopment
